import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const SolicitationService = {
    list: (filter) => axios.post(API_KEEPER + "/ecap-solicitation/list", filter).then(({ data }) => data).catch((err) => { throw err }),

    get: async (id) => axios.get(API_KEEPER + "/ecap-solicitation/" + id).then(({data}) => data).catch((err) => { throw err }),

    create: async (data) => axios.post(API_KEEPER + "/ecap-solicitation", data).then(({data}) => data).catch((err) => { throw err }),

    edit: async (id, data) => axios.put(API_KEEPER + "/ecap-solicitation/" + id, data).then(({data}) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(API_KEEPER + "/ecap-solicitation/" + id).catch((err) => { throw err }),

    reopen: async (id) => axios.post(API_KEEPER + "/ecap-solicitation/reopen/" + id).catch((err) => { throw err }),
};

export default SolicitationService;